import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PropertiesPage from './pages/PropertiesPage';
import CleanersPage from './pages/CleanersPage';
import AdminsPage from './pages/AdminsPage';
import AccessPage from './pages/AccessPage';
import CockpitPage from './pages/CockpitPage';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import PropertyDetails from './pages/PropertyDetails';
import PropertyManagePage from './pages/PropertyManagePage';
import CleanerManagePage from './pages/CleanerManagePage';
import AdminManagePage from './pages/AdminManagePage';
import AccountPage from './pages/AccountPage';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<ProtectedRoute><CockpitPage /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><AnalyticsDashboard /></ProtectedRoute>} />
      <Route path="/properties" element={<ProtectedRoute><PropertiesPage /></ProtectedRoute>} />
      <Route path="/properties/:propertyId" element={<ProtectedRoute><PropertyDetails /></ProtectedRoute>} />
      <Route path="/properties/:propertyId/manage" element={<ProtectedRoute><PropertyManagePage /></ProtectedRoute>} />
      <Route path="/cleaners" element={<ProtectedRoute><CleanersPage /></ProtectedRoute>} />
      <Route path="/cleaners/:cleanerId/manage" element={<ProtectedRoute><CleanerManagePage /></ProtectedRoute>} />
      <Route path="/admins" element={<ProtectedRoute><AdminsPage /></ProtectedRoute>} />
      <Route path="/admins/:adminId/manage" element={<ProtectedRoute><AdminManagePage /></ProtectedRoute>} />
      <Route path="/access" element={<ProtectedRoute><AccessPage /></ProtectedRoute>} />
      <Route path="/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
    </Routes>
  );
};

export default AppRoutes;
